import { render, staticRenderFns } from "./Testimonies.vue?vue&type=template&id=4e2676e1&"
import script from "./Testimonies.vue?vue&type=script&lang=js&"
export * from "./Testimonies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports